import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { CourseExports } from '../../../../pages/course-export/CourseExports';
import { RoutePending } from '../../../../components/molecules/loader/RoutePending';
import { getListCourseExportsQueryOptions } from '../../../../pages/course-export/components/CourseExports.queries';
import { getListTagsQueryOptions } from '../../../../pages/project/components/ProjectsCore.queries';

export const Route = createFileRoute('/_private/_home/course-exports/')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(getListCourseExportsQueryOptions(context.apiClient));
    void context.queryClient.prefetchQuery(getListTagsQueryOptions(context.apiClient));
  },
  component: CourseExportsRoute,
  pendingComponent: () => <RoutePending label="Loading dispatches..." />,
});

function CourseExportsRoute() {
  const { apiClient } = Route.useRouteContext();
  return <CourseExports portalApiClient={apiClient} />;
}
